class VideoData {

    constructor(result) {

        this.videoId = String(result.video_id).trim();
        this.videoTitle = String(result.video_title).trim();
        this.videoLength = String(result.video_length).trim();
        this.videoDescription = String(result.video_description).trim();
        this.videoViews = +(result.video_views);
        this.videoLikes = +(result.video_likes);
        this.videoPublished = String(result.video_published).trim();
        this.videoState = String(result.video_state).trim();

    }

    getLabel() {

        return this.video_title ? this.video_title : this.video_id;

    }

}

export default VideoData;